<template src="./card.pug" />
<style lang="scss" src="./card.scss" scoped ></style>

<script>
import { mapState } from 'vuex'
import { validationMixin } from 'vuelidate'
import { numeric } from 'vuelidate/lib/validators'
import validate from '@/mixins/validate'
import scroll from '@/utils/scroll'
import { vLength } from '@/utils/helpers'

export default {
    mixins: [validationMixin, validate],
    data: () => ({
        filters: {
            clientId: null,
            paymentId: null,
            phoneNumber: null
        },
        sorting: {}
    }),
    validations: {
        filters: {
            clientId: {
                numeric
            },
            paymentId: {
                numeric
            },
            phoneNumber: {
                length: vLength(9)
            }
        }
    },
    computed: {
        ...mapState({
            cards: state => state.card.cards,
            pagination: state => state.card.pagination,
            appliedFilters: state => state.card.filters,
            isTableLoad: state => state.card.isLoaded
        }),
        headers: function() {
            return [
                'id', 'clientId', 'phoneNumber', 'paymentId', 'cardMask',
                'cardToken', 'default', 'errorCount', 'createdAt', 'updatedAt'
            ].map(it => ({
                text: this.$vuetify.lang.t(`$vuetify.pages.Cards.table.${it}`),
                value: `"${it}"`
            }))
        }
    },
    watch: {
        sorting: {
            handler() {
                this.getCardsByPage()
            },
            deep: true
        }
    },
    created: function() {
        this.filters = Object.assign({}, this.appliedFilters)
        this.getCardsByPage(this.pagination.page)
    },
    beforeRouteLeave: function(to, from, next) {
        this.$store.commit('card/SET_PAGINATION', { page: 1, length: null })
        next()
    },
    methods: {
        submit() {
            this.$store.commit('card/SET_FILTERS', Object.assign({}, this.filters))
            this.getCardsByPage()
        },
        getCardsByPage(page = 1, isScrollEnable = false, excel = false) {
            if (this.$v.$invalid) {
                this.$v.$touch()
            } else {
                this.$store.dispatch('card/getCards', {
                    page,
                    excel,
                    column: this.sorting.sortBy,
                    direction: this.sorting.descending ? 'desc' : 'asc',
                    ...this.appliedFilters,
                    phoneNumber: this.filters.phoneNumber && `380${this.filters.phoneNumber}`
                }).then(_ => {
                    if (isScrollEnable) {
                        scroll(this.$refs.table)
                    }
                })
            }
        },
        onPageChange(page) {
            if (page !== this.pagination.page) {
                this.getCardsByPage(page, true)
            }
        },
        resetCards() {
            this.filters = Object.assign({}, {
                clientId: null,
                paymentId: null,
                phoneNumber: null
            })
            this.$store.commit('card/RESET_CARDS')
            this.getCardsByPage()
            this.$v.reset()
        },
        exportToExcel() {
            this.getCardsByPage(1, false, true)
        }
    }
}
</script>
